import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { class: "card-left-area" }
const _hoisted_2 = { class: "card-num text-right" }
const _hoisted_3 = {
  class: "row justify-between",
  style: {"padding":"0 10px"}
}
const _hoisted_4 = {
  class: "flex items-center",
  style: {"width":"140px","margin-right":"15px"}
}
const _hoisted_5 = {
  class: "q-mb-none text-center",
  style: {"font-weight":"bold","letter-spacing":"1px","font-size":"1rem"}
}
const _hoisted_6 = {
  key: 1,
  class: "app-low-right q-gutter-x-xs",
  style: {"width":"calc(100% - 250px)"}
}
const _hoisted_7 = {
  key: 0,
  class: "app-lows"
}
const _hoisted_8 = { class: "low-deleterious" }
const _hoisted_9 = {
  key: 1,
  class: "app-lows"
}
const _hoisted_10 = { class: "low-prtr" }
const _hoisted_11 = {
  key: 2,
  class: "app-lows"
}
const _hoisted_12 = { class: "low-safety" }
const _hoisted_13 = {
  key: 3,
  class: "app-lows flex items-center justify-center",
  style: {"width":"60%","margin":"0px"}
}
const _hoisted_14 = {
  key: 4,
  class: "app-lows flex items-center justify-center",
  style: {"width":"480px","margin":"0px"}
}
const _hoisted_15 = {
  class: "deletebtn",
  style: {"margin":"0"}
}
const _hoisted_16 = { class: "row items-start order-card-container q-mt-sm q-mb-sm" }
const _hoisted_17 = {
  class: "row",
  style: {"width":"140px","margin-right":"15px","margin-top":"-2px"}
}
const _hoisted_18 = { class: "col q-gutter-y-sm" }
const _hoisted_19 = { class: "row" }
const _hoisted_20 = {
  class: "row q-gutter-x-xl",
  style: {"margin-top":"0"}
}
const _hoisted_21 = { class: "row items-center supplier-name" }
const _hoisted_22 = { class: "row items-center supplier-code" }
const _hoisted_23 = { class: "row items-center" }
const _hoisted_24 = { class: "row" }
const _hoisted_25 = {
  class: "q-mr-sm row items-center",
  style: {"width":"268px"}
}
const _hoisted_26 = { class: "q-mr-sm row items-center" }
const _hoisted_27 = { class: "row justify-between" }
const _hoisted_28 = { class: "row items-center" }
const _hoisted_29 = { class: "text-weight-bold row items-center" }
const _hoisted_30 = {
  class: "row justify-between order-bottom",
  style: {"border-top":"1px solid var(--q-whiteBorder)","padding":"10px 10px 0"}
}
const _hoisted_31 = {
  class: "flex justify-end items-center",
  style: {"width":"calc(100% - 150px)"}
}
const _hoisted_32 = {
  key: 0,
  class: "flex items-center des-capacity",
  style: {"width":"200px","margin-right":"20px"}
}
const _hoisted_33 = {
  class: "flex items-center",
  style: {"width":"170px","margin-right":"-5px"}
}
const _hoisted_34 = {
  key: 0,
  class: "text-weight-bold",
  style: {"font-size":"0.8rem","margin-right":"10px"}
}
const _hoisted_35 = {
  key: 1,
  class: "text-weight-bold requier",
  style: {"font-size":"0.8rem","margin-right":"10px"}
}

import { ref, computed, inject } from 'vue';
import AtomImage from '../images/AtomImage.vue';
import ApplyLowLabel from '../label/ApplyLowLabel.vue';
import commaFormat from '../../common/utils/numberUtils';

// データ interface
interface Data {
  cart_result_detail_atto_id: string;
  atto_id: string;
  structure_svg: string;
  cas: string;
  reg_group_code: string;
  reg_group_name: string;
  prtr_name: string;
  ishl_name: string;
  supplier_name: string;
  id_number: string;
  name1: string;
  capacity: string;
  packing: string;
  purity: string;
  selling_price: string;
  standard_delivery_time_name: string;
  desired_capacity: string | null;
  desired_quantity: string | null;
  comment: string;
}

interface Props {
  // 番号
  num: number;
  // データ
  data: Data;
  // 問い合わせフラグ
  quoteFlg: boolean;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'OrderCard',
  props: {
    num: {},
    data: {},
    quoteFlg: { type: Boolean }
  },
  emits: ["delete", "inputComment"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const commentShownFlg = ref(false);

const inputData = ref(computed(() => props.data));

const emit = __emit;

// 削除
const deleteOrder = () => {
  emit('delete');
};

// コメント入力
const inputComment = () => {
  emit('inputComment');
};
// パンチアウトタイプ
const poType = inject('poType');
const cartLimitFlg = inject('cartLimitFlg');

const init = () => {
  if (poType === 'PO_RE_ARIBA') {
    commentShownFlg.value = true;
  }
};

init();

return (_ctx: any,_cache: any) => {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card = _resolveComponent("q-card")!

  return (_openBlock(), _createBlock(_component_q_card, _mergeProps(props, {
    class: "q-mb-sm flex order-card",
    flat: "",
    bordered: "",
    style: {"padding":"0"}
  }), {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("p", _hoisted_2, _toDisplayString(props.num + 1), 1)
      ]),
      _createVNode(_component_q_card_section, {
        class: "order-headercard",
        style: {"border-left":"1px solid var(--q-whiteBorder)","border-radius":"0","padding-bottom":"0","width":"calc(100% - 45px)","padding":"10px 0"}
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.data.atto_id), 1)
            ]),
            (props.quoteFlg)
              ? (_openBlock(), _createBlock(ApplyLowLabel, {
                  key: 0,
                  "classification-code": _ctx.data.reg_group_code,
                  "reg-name": _ctx.data.reg_group_name,
                  "prtr-name": _ctx.data.prtr_name,
                  "ishl-name": _ctx.data.ishl_name,
                  style: _normalizeStyle(
            'width: calc(100% - 250px);' + (_ctx.data.reg_group_code === null ? 'display: none;' : '')
          )
                }, null, 8, ["classification-code", "reg-name", "prtr-name", "ishl-name", "style"]))
              : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  (_ctx.data.reg_group_code === '3')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.data.reg_group_name), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (
              (_ctx.data.reg_group_code === '5' ||
                _ctx.data.reg_group_code === '6' ||
                (_ctx.data.prtr_name !== null && _ctx.data.prtr_name !== '')) &&
              _ctx.data.reg_group_code !== '2'
            )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.data.prtr_name), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (
              (_ctx.data.reg_group_code === '7' || (_ctx.data.ishl_name !== null && _ctx.data.ishl_name !== '')) &&
              _ctx.data.reg_group_code !== '2'
            )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                        _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.data.ishl_name), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (
              _ctx.data.reg_group_code === '1' ||
              _ctx.data.reg_group_code === '4' ||
              _ctx.data.reg_group_code === '8'
            )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, _cache[7] || (_cache[7] = [
                        _createElementVNode("label", {
                          class: "low-none flex items-center justify-center",
                          style: {"background-color":"rgba(210, 210, 210, 0.8)","font-size":"14px","line-height":"1.5","border-radius":"0","font-weight":"bold","letter-spacing":"1px","padding":"4px 0","width":"100%"}
                        }, "取り扱いは中止になりました。", -1)
                      ])))
                    : (_ctx.data.reg_group_code === '2')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_14, _cache[8] || (_cache[8] = [
                          _createElementVNode("label", {
                            class: "low-none flex items-center justify-center",
                            style: {"background-color":"rgba(210, 210, 210, 0.8)","padding":"4px 0","letter-spacing":"1px","font-size":"14px","line-height":"1.5","width":"100%"}
                          }, "毒物は注文することができませんのでお問い合わせください。", -1)
                        ])))
                      : _createCommentVNode("", true)
                ])),
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_component_q_btn, {
                icon: "mdi-trash-can-outline",
                label: "削除",
                outline: "",
                disable: _unref(poType) === 'PO_RE_ARIBA' || _unref(cartLimitFlg) === true,
                style: {"color":"var(--q-delete)","height":"30px","min-height":"unset","background-color":"white"},
                onClick: _cache[0] || (_cache[0] = ($event: any) => (deleteOrder()))
              }, null, 8, ["disable"])
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createVNode(AtomImage, {
                exatoms: _ctx.data.structure_svg
              }, null, 8, ["exatoms"])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _cache[9] || (_cache[9] = _createElementVNode("label", { class: "q-mr-md card-title" }, "CAS No.", -1)),
                _createElementVNode("span", null, _toDisplayString(_ctx.data.cas ? _ctx.data.cas : '-'), 1)
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _cache[10] || (_cache[10] = _createElementVNode("label", { class: "q-mr-md card-title" }, "サプライヤ", -1)),
                  _createElementVNode("span", null, _toDisplayString(_ctx.data.supplier_name ? _ctx.data.supplier_name : '-'), 1)
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _cache[11] || (_cache[11] = _createElementVNode("label", { class: "q-mr-md card-title" }, "サプライヤ商品コード", -1)),
                  _createElementVNode("span", null, _toDisplayString(_ctx.data.id_number ? _ctx.data.id_number : '-'), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_23, [
                _cache[12] || (_cache[12] = _createElementVNode("label", { class: "q-mr-md card-title" }, "化学名", -1)),
                _createElementVNode("span", null, _toDisplayString(_ctx.data.name1 ? _ctx.data.name1 : '-'), 1)
              ]),
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, [
                  _cache[13] || (_cache[13] = _createElementVNode("label", { class: "q-mr-md card-title" }, "容量", -1)),
                  _createElementVNode("span", null, _toDisplayString(_ctx.data.capacity ? _ctx.data.capacity : 'ご希望容量'), 1)
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _cache[14] || (_cache[14] = _createElementVNode("label", { class: "q-mr-md card-title" }, "純度", -1)),
                  _createElementVNode("span", null, _toDisplayString(_ctx.data.purity ? _ctx.data.purity : '-'), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  _cache[15] || (_cache[15] = _createElementVNode("label", { class: "q-mr-md text-weight-bold card-title" }, "納期", -1)),
                  _createElementVNode("span", {
                    class: _normalizeClass(!_ctx.data.selling_price && 'order-card-inquiry-required')
                  }, _toDisplayString(_ctx.data.standard_delivery_time_name
                    ? _ctx.data.standard_delivery_time_name
                    : '要問い合わせ'), 3)
                ]),
                _createElementVNode("div", _hoisted_29, [
                  _cache[16] || (_cache[16] = _createElementVNode("label", { class: "q-mr-md card-title" }, "納入価格（税抜）", -1)),
                  _createElementVNode("span", {
                    style: {"font-size":"1.1rem","letter-spacing":"1px"},
                    class: _normalizeClass(!_ctx.data.selling_price && 'order-card-inquiry-required')
                  }, _toDisplayString(_ctx.data.selling_price
                    ? `¥${_unref(commaFormat)(Number(_ctx.data.selling_price))}`
                    : '要問い合わせ'), 3)
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_30, [
            (_unref(poType) !== 'PO_RE_ARIBA')
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: _normalizeClass(
            'comment-btn flex items-center justify-center q-gutter-x-sm ' +
            (commentShownFlg.value ? 'comment-hidden' : '')
          ),
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (commentShownFlg.value ? (commentShownFlg.value = false) : (commentShownFlg.value = true)))
                }, [
                  _createVNode(_component_q_icon, {
                    color: "black",
                    size: "20px",
                    name: "mdi-chevron-down"
                  }),
                  _cache[17] || (_cache[17] = _createElementVNode("p", { class: "q-mb-none" }, "コメントを入力", -1))
                ], 2))
              : (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  class: _normalizeClass('comment-btn flex items-center justify-center q-gutter-x-sm comment-hidden'),
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (commentShownFlg.value = true))
                }, [
                  _createVNode(_component_q_icon, {
                    color: "black",
                    size: "20px",
                    name: "mdi-chevron-down"
                  }),
                  _cache[18] || (_cache[18] = _createElementVNode("p", { class: "q-mb-none" }, "コメント", -1))
                ])),
            _createElementVNode("div", _hoisted_31, [
              (_ctx.quoteFlg)
                ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                    _cache[19] || (_cache[19] = _createElementVNode("label", {
                      class: "text-weight-bold requier",
                      style: {"font-size":"0.8rem","margin-right":"10px"}
                    }, "希望容量", -1)),
                    _createVNode(_component_q_input, {
                      modelValue: inputData.value.desired_capacity,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((inputData.value.desired_capacity) = $event)),
                      outlined: "",
                      clearable: "",
                      dense: "",
                      maxlength: "30",
                      disable: !_ctx.quoteFlg || _unref(cartLimitFlg) === true,
                      pattern: "^[0-9A-Za-z]+$",
                      style: {"width":"110px"},
                      class: "input-area left-input",
                      onBlur: inputComment
                    }, null, 8, ["modelValue", "disable"])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_33, [
                (_unref(poType) === 'PO_RE_ARIBA')
                  ? (_openBlock(), _createElementBlock("label", _hoisted_34, "数量"))
                  : (_openBlock(), _createElementBlock("label", _hoisted_35, "数量")),
                _createVNode(_component_q_input, {
                  modelValue: inputData.value.desired_quantity,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((inputData.value.desired_quantity) = $event)),
                  outlined: "",
                  dense: "",
                  mask: "##",
                  maxlength: "2",
                  "input-class": "text-right",
                  class: "input-area",
                  style: {"width":"100px"},
                  disable: _unref(poType) === 'PO_RE_ARIBA' || _unref(cartLimitFlg) === true,
                  onBlur: inputComment
                }, null, 8, ["modelValue", "disable"])
              ])
            ]),
            (_unref(poType) === 'PO_RE_ARIBA')
              ? (_openBlock(), _createElementBlock("div", {
                  key: 2,
                  class: _normalizeClass(_ctx.quoteFlg ? 'inquiry-comment-area' : 'order-comment-area'),
                  style: {"width":"100%","margin-top":"8px","padding-left":"40px"}
                }, [
                  _createVNode(_component_q_input, {
                    modelValue: inputData.value.comment,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((inputData.value.comment) = $event)),
                    outlined: "",
                    clearable: "",
                    dense: "",
                    counter: "",
                    rows: "1",
                    maxlength: "200",
                    type: "textarea",
                    class: "input-area left-input",
                    disable: _unref(poType) === 'PO_RE_ARIBA' || _unref(cartLimitFlg) === true,
                    onBlur: inputComment
                  }, null, 8, ["modelValue", "disable"])
                ], 2))
              : (commentShownFlg.value)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 3,
                    class: _normalizeClass(_ctx.quoteFlg ? 'inquiry-comment-area' : 'order-comment-area'),
                    style: {"width":"100%","margin-top":"8px","padding-left":"40px"}
                  }, [
                    _createVNode(_component_q_input, {
                      modelValue: inputData.value.comment,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((inputData.value.comment) = $event)),
                      outlined: "",
                      clearable: "",
                      dense: "",
                      counter: "",
                      rows: "1",
                      maxlength: "200",
                      type: "textarea",
                      class: "input-area left-input",
                      disable: _unref(poType) === 'PO_RE_ARIBA' || _unref(cartLimitFlg) === true,
                      onBlur: inputComment
                    }, null, 8, ["modelValue", "disable"])
                  ], 2))
                : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 16))
}
}

})